import Vue from 'vue'
import Router from 'vue-router'
import { getAllRoles } from './roles'
import store from './store'

Vue.use(Router)

const options = {
  mode: 'history',
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login'),
          meta: {
            allow: ['GUEST_ROLE'],
          },
        },
        {
          name: 'Register',
          path: 'register',
          component: () => import('@/views/pages/Register'),
          meta: {
            allow: ['GUEST_ROLE'],
          },
        },
        {
          name: 'Recovery',
          path: 'recovery',
          component: () => import('@/views/pages/RecoveryPassword'),
          meta: {
            allow: ['GUEST_ROLE'],
          },
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'ClientBank',
          meta: { title_name: 'Аналитика', allow: getAllRoles() },
          path: '/',
          component: () => import('@/views/pages/analytics/Analytics'),
        },
        {
          name: 'Companies',
          meta: { title_name: 'Филиалы', allow: ['SUPER_ADMIN_ROLE', 'ADMIN_ROLE'] },
          path: 'digest/companies',
          /*path: '/companies',*/
          component: () => import('@/views/pages/companies/MainCompanies'),
        },
        {
          name: 'EditCompany',
          meta: { title_name: 'Редактирование компании', allow: ['SUPER_ADMIN_ROLE', 'ADMIN_ROLE'] },
          path: '/companies/:id/edit-company',
          component: () => import('@/views/pages/companies/components/EditCompany'),
        },
        {
          name: 'Users',
          meta: { title_name: 'Пользователи', allow: ['SUPER_ADMIN_ROLE', 'ADMIN_ROLE'] },
          path: '/users',
          component: () => import('@/views/pages/users/MainUsers'),
        },
        {
          name: 'EditUser',
          meta: { title_name: 'Редактирование пользователя' },
          path: '/users/:id/edit-user',
          component: () => import('@/views/pages/users/components/EditUser'),
        },
        /*{
            name: 'Invites',
            meta: { title_name: 'Приглашения', allow: ['ADMIN_ROLE'] },
            path: '/invites',
            component: () => import('@/views/pages/invites/MainInvites'),
        },*/
        {
          name: 'Counterparties',
          meta: { title_name: 'Клиенты', allow: ['ADMIN_ROLE'] },
          path: '/counterparties',
          component: () => import('@/views/pages/counterparties/MainCounterparties'),
        },
        {
          name: 'simcards',
          meta: { title_name: 'Сим карты', allow: ['ADMIN_ROLE'] },
          path: 'digest/simcards',
          component: () => import('@/views/pages/tel/SimCards'),
        },
        {
          name: 'CallsHistory_1',
          meta: { title_name: 'Все звонки', allow: ['ADMIN_ROLE'] },
          /*path: '/callshistory',*/
          path: 'callshistory/callshistory_1',
          component: () => import('@/views/pages/calls-history/CallsHistory'),
        },
        {
          name: 'CallsHistory_2',
          meta: { title_name: 'Мои звонки', allow: ['ADMIN_ROLE'] },
          path: 'callshistory/callshistory_2',
          component: () => import('@/views/pages/calls-history/CallsHistory'),
        },
        {
          name: 'IpNumbers',
          meta: { title_name: 'Внутренние номера IP', allow: ['ADMIN_ROLE'] },
          path: 'digest/ipnumbers',
          component: () => import('@/views/pages/ip-numbers/IpNumbers'),
        },
        {
          name: 'ExternalServer',
          meta: { title_name: 'Внешние сервера', allow: ['ADMIN_ROLE'] },
          path: 'integrations/externalserver',
          component: () => import('@/views/pages/external-server/ExternalServer'),
        },
        {
          name: 'Integrations',
          meta: { title_name: 'Интеграции', allow: ['ADMIN_ROLE'] },
          path: '/integrations',
          component: () => import('@/views/pages/integrations/Integrations'),
        },
        {
          name: 'General',
          meta: { title_name: 'Общие сценарии', allow: ['ADMIN_ROLE'] },
          path: 'scenarios/general',
          component: () => import('@/views/pages/scenarios/General'),
        },
        {
          name: 'ForSims',
          meta: { title_name: 'Сценарии для Сим', allow: ['ADMIN_ROLE'] },
          path: 'scenarios/forsims',
          component: () => import('@/views/pages/scenarios/ForSims'),
        },
        {
          name: 'ForServers',
          meta: { title_name: 'Сценарии для Серверов', allow: ['ADMIN_ROLE'] },
          path: 'scenarios/forservers',
          component: () => import('@/views/pages/scenarios/ForServers'),
        },
        {
          name: 'CallForwarding',
          meta: { title_name: 'Переадресация внутренних номеров', allow: ['ADMIN_ROLE'] },
          path: 'scenarios/callforwarding',
          component: () => import('@/views/pages/scenarios/CallForwarding'),
        },
        {
          name: 'Item',
          meta: { title_name: 'Подпункт', allow: ['ADMIN_ROLE'] },
          path: 'digest/item',
          component: () => import('@/views/pages/digest/Item'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
          meta: {
            allow: ['GUEST_ROLE'],
          },
        },
      ],
    },
  ],
}

const router = new Router(options)

router.beforeEach((to, from, next) => {
  const availableRoutesMap = ['Login', 'Register', 'Recovery']

  if (availableRoutesMap.indexOf(to.name) === -1 && !store.getters.isAuthenticated) {
    next({
      name: 'Login',
      params: { nextUrl: to.fullPath },
    })
    return
  }

  if (to.name === 'authorization' && store.getters.isAuthenticated) {
    next({ path: '/' })
    return
  }

  // if (!canUserEnter(to.matched)) {
  //   next({ name: '404 Error' })
  //   return
  // }

  next()
})

/**
 * Проверка на видимость маршрута.
 *
 * @param routeName
 * @returns {boolean}
 */
function isRouteVisible (routeName) {
  return options.routes.some(route => {
    if (route.name !== routeName) {
      return false
    }
    if (!('meta' in route) && !('allow' in route.meta)) {
      return false
    }

    return route.meta.allow.includes(store.getters.getUserRole)
  })
}

/**
 * Проверка на то, что может ли пользователь пройти по указанному роуту.
 *
 * @param matched
 * @returns {boolean}
 */
function canUserEnter (matched) {
  return matched.some(record => {
    if (!('allow' in record.meta)) {
      return false
    }
    return record.meta.allow.includes(store.getters.getUserRole)
  })
}

export { isRouteVisible }
export default router
